<template>
	<div>
		<GenericSelector
			:value="value"
			@input="val => handleInput(val)"
			:options="options"
			:showOptions="showOptions"
			:canEdit="showOptions"
			:loading="!users"
			:displayCb="userDisplay"
			:disableNoneSelectedAlert="disableNoneSelectedAlert"
			:hideSelected="showSelectedOnEdit ? !showOptions : hideSelected"
		>	
			<template v-if="label" v-slot:selectedHeader>
				<slot name="label">
					<div class="list-group-item text-sm font-weight-bold">{{ label }}</div>
				</slot>
			</template>		
			
			<template v-slot:unselectedHeader>
				<div class="pl-3 my-2 d-flex flex-row align-items-center" style="gap: 1rem">
					<SearchBar v-if="showOptions" v-model="search" :debounce="false" />

					<button
						type="button"
						@click="showOptions = !showOptions"
						class="btn btn-primary ml-auto"
					>
						<b-icon v-if="!showOptions" icon="plus" class="h6 mb-0 mr-1"/>{{ showOptions ? $t('done') : $t('edit') }}
					</button>
				</div>
			</template>
		</GenericSelector>
	</div>
</template>

<script>
import GenericSelector from '../Inputs/GenericSelector.vue';
import SearchBar from '../Table/SearchBar.vue';

export default {
	components: {
		GenericSelector,
		SearchBar,
	},
    props: {
		value: Array,
		users: Array,
		loading: {
			type: Boolean,
			default: false,
		},
		displayCb: {
			type: Function,
			default: user => user.displayname ,
		},
		label: String,
		disableNoneSelectedAlert: Boolean,
		hideSelected: Boolean,
		showSelectedOnEdit: Boolean,
        limit: Number,
        showStudentIds: Boolean
	},
    data() {
        return {
			search: '',
			showOptions: false,
        };
    },
    methods: {
        handleInput(value){
            if(value.length > this.limit) value.shift();
            this.$emit('input', value)
        },
        userDisplay(user){
            if(this.showStudentIds) return user.displayname + ' ' + user.student_id
            return user.displayname
        }
    },
    computed: {
		options() {
			return this.users.filter(user => !this.search
				|| user.displayname && user.displayname.toLowerCase().includes(this.search.toLowerCase())
				|| user.username && user.username.toLowerCase().includes(this.search.toLowerCase())
                || user.student_id && String(user.student_id).includes(this.search)
			)
		},
    },
};
</script>
